import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Ongoing from "@/components/Ongoing";
import RealEstate from "@/components/RealEstate";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, anchors: true }}>
      <div className="bg-white text-slate-900 font-sans antialiased overflow-x-clip">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Stats />
          <Manifesto />
          <Services />
          <Ongoing />
          <Projects />
          <RealEstate />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
